import { render, staticRenderFns } from "./detail-info.vue?vue&type=template&id=5f38c5b7&scoped=true&"
import script from "./detail-info.vue?vue&type=script&lang=js&"
export * from "./detail-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f38c5b7",
  null
  
)

export default component.exports